// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zJ-z","smallCardRow":"AJ-z","largeCardRow":"BJ-z","productSearchRow":"CJ-z","curatedRow":"DJ-z"};